// eslint-disable-next-line jira/import-whitelist
import { transformUrlToAddonAndModuleKeys } from '@atlassian/jira-connect-iframe-legacy/src/services/transformers.tsx';
import { staticProjectSidebarNavigationResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { createResource } from '@atlassian/react-resource-router';
import { RESOURCE_TYPE_CONNECT_PROJECT } from './constants.tsx';

// eslint-disable-next-line jira/router/no-daisy-chaining-resources, @typescript-eslint/no-explicit-any
export const connectProjectResources = createResource<any>({
	type: RESOURCE_TYPE_CONNECT_PROJECT,
	getKey: ({ query }) => {
		const { addonKey, moduleKey } = transformUrlToAddonAndModuleKeys(query);

		if (addonKey !== '' && moduleKey !== '') {
			return `${addonKey}-${moduleKey}`;
		}
		return 'state';
	},
	depends: [staticProjectSidebarNavigationResource.type],
	getDataLoader: () =>
		import(
			/* webpackChunkName: "async-resource-connect-addon-projects", jiraSpaEntry: "async-resource-connect-addon-projects" */ './controllers/get-addon-data'
		),
});
